"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _core = require("@material-ui/core");

var _ClearRounded = _interopRequireDefault(require("@material-ui/icons/ClearRounded"));

var _reactDnd = require("react-dnd");

var _reactGridLayout = require("react-grid-layout");

var _GridDivider = _interopRequireDefault(require("./GridDivider"));

var _ContainerDinamic = _interopRequireDefault(require("./dynamic-form/inputs/ContainerDinamic"));

var _ButtonElement = _interopRequireDefault(require("./form-container/inputs/ButtonElement"));

var _LabelElement = _interopRequireDefault(require("./form-container/inputs/LabelElement"));

var _DateElement = _interopRequireDefault(require("./form-container/inputs/DateElement"));

var _AccordionElement = _interopRequireDefault(require("./form-container/inputs/AccordionElement"));

var _CheckboxElement = _interopRequireDefault(require("./form-container/inputs/CheckboxElement"));

var _RadioElement = _interopRequireDefault(require("./form-container/inputs/RadioElement"));

var _SelectElement = _interopRequireDefault(require("./form-container/inputs/SelectElement"));

var _ImageElement = _interopRequireDefault(require("./form-container/inputs/ImageElement"));

require("react-grid-layout/css/styles.css");

require("react-resizable/css/styles.css");

var _templateObject, _templateObject2;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ResponsiveGridLayout = (0, _reactGridLayout.WidthProvider)(_reactGridLayout.Responsive);

var ElementContainer = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  & {\n    height: 100%;\n  }\n\n  &.centered .field {\n    height: 100%;\n    display: flex;\n    width: 100%;\n    align-items: center;\n  }\n"])));

var Segment = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: relative;\n  background: #ffffff;\n  padding: 1em 1em;\n"])));

var elementTarget = {
  drop: function drop(props, monitor, component) {
    if (monitor.didDrop()) {
      // If you want, you can check whether some nested
      // target already handled drop
      return;
    }

    return {
      row: component.formDnDContainerStore.row,
      col: component.formDnDContainerStore.col
    };
  }
};

var collect = function collect(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    hovered: monitor.isOver(),
    item: monitor.getItem()
  };
};

var ElementType = function ElementType(_ref) {
  var item = _ref.item;

  switch (item.type) {
    case "label":
      return /*#__PURE__*/_react.default.createElement(_LabelElement.default, {
        item: item
      });

    case "input":
      return /*#__PURE__*/_react.default.createElement(_core.TextField, _extends({
        disabled: true
      }, item.attributes));

    case "date":
      return /*#__PURE__*/_react.default.createElement(_DateElement.default, {
        item: item
      });

    case "textarea":
      return /*#__PURE__*/_react.default.createElement(_core.TextField, _extends({
        disabled: true
      }, item.attributes, {
        multiline: true,
        rows: 4
      }));

    case "accordion":
      return /*#__PURE__*/_react.default.createElement(_AccordionElement.default, {
        item: item
      });

    case "button":
      {
        return /*#__PURE__*/_react.default.createElement(_ButtonElement.default, {
          item: item
        });
      }

    case "checkbox":
      return /*#__PURE__*/_react.default.createElement(_CheckboxElement.default, {
        item: item
      });

    case "radio":
      return /*#__PURE__*/_react.default.createElement(_RadioElement.default, {
        item: item
      });

    case "select":
      return /*#__PURE__*/_react.default.createElement(_SelectElement.default, {
        item: item
      });

    case "image":
      return /*#__PURE__*/_react.default.createElement(_ImageElement.default, {
        item: item
      });

    case "container":
      return /*#__PURE__*/_react.default.createElement(_ContainerDinamic.default, {
        props: item
      });

    /* case 'autocomplete':
    return <SearchInput search icon="search" {...attributes} />;*/

    default:
      return;
  }
};
/* Los distintos elementos que se agregaran en el formulario */


var itemForm = function itemForm(propItem, handleClick, handleRemove, selectedId) {
  var _item$isChild;

  var item = propItem;
  return /*#__PURE__*/_react.default.createElement("div", {
    key: item.i,
    "data-grid": item,
    className: selectedId === item.i && item.classes,
    style: {
      height: "auto !important"
    }
  }, !((_item$isChild = item.isChild) !== null && _item$isChild !== void 0 && _item$isChild.parentId) && /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    "aria-label": "delete",
    size: "small",
    style: {
      zIndex: 110,
      position: "absolute",
      right: 0,
      top: item.type === "button" ? 25 : 30,
      display: selectedId !== item.i ? "none" : "block"
    },
    onClick: function onClick() {
      return handleRemove(item);
    }
  }, /*#__PURE__*/_react.default.createElement(_ClearRounded.default, {
    fontSize: "inherit"
  })), /*#__PURE__*/_react.default.createElement(ElementContainer, {
    className: "".concat(item.type === "checkbox" ? "centered" : ""),
    onClick: function onClick() {
      return handleClick(item, item.i);
    },
    style: item.type === "label" ? {
      display: "flex",
      justifyContent: item.attributes.justifyContent
    } : {}
  }, /*#__PURE__*/_react.default.createElement(ElementType, {
    item: item
  })));
};

var FormContainerDnDStore = function FormContainerDnDStore(entityStore, formStore) {
  var _this = this;

  _classCallCheck(this, FormContainerDnDStore);

  _defineProperty(this, "objectsForm", []);

  _defineProperty(this, "row", 0);

  _defineProperty(this, "col", 0);

  _defineProperty(this, "updateObjectsForm", function (objectsForm) {
    _this.objectsForm = objectsForm;
  });

  _defineProperty(this, "setRow", function (row) {
    _this.row = row;
  });

  _defineProperty(this, "setCol", function (col) {
    _this.col = col;
  });

  this.entityStore = entityStore;
  this.formStore = formStore;
};

var FormContainerDnd = /*#__PURE__*/function (_Component) {
  _inherits(FormContainerDnd, _Component);

  var _super = _createSuper(FormContainerDnd);

  function FormContainerDnd(props) {
    var _this2;

    _classCallCheck(this, FormContainerDnd);

    _this2 = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this2), "setRow", function (row) {
      _this2.formDnDContainerStore.setRow(row);
    });

    _defineProperty(_assertThisInitialized(_this2), "setCol", function (col) {
      _this2.formDnDContainerStore.setCol(col);
    });

    _defineProperty(_assertThisInitialized(_this2), "handleDrawable", function (layout, oldItem, newItem, placeholder, e, element) {
      _this2.props.handleItemPropertiesChange(layout);
    });

    _defineProperty(_assertThisInitialized(_this2), "handleItemSelected", function (item, key) {
      if (item.i !== "step-0") _this2.props.handleItemSelected(item, key);
    });

    _this2.formDnDContainerStore = new FormContainerDnDStore(_this2.props.entityStore, _this2.props.formStore);
    _this2.containerRef = /*#__PURE__*/_react.default.createRef();
    return _this2;
  }

  _createClass(FormContainerDnd, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.formDnDContainerStore.updateObjectsForm(this.props.objectsForm);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          connectDropTarget = _this$props.connectDropTarget,
          hovered = _this$props.hovered,
          handleRemoveItem = _this$props.handleRemoveItem,
          container = _this$props.container,
          itemProperties = _this$props.itemProperties,
          optionsGridLayout = _this$props.optionsGridLayout;
      var isStaticHeigth = optionsGridLayout.isStaticHeigth,
          containerPaddingSizeX = optionsGridLayout.containerPaddingSizeX,
          containerPaddingSizeY = optionsGridLayout.containerPaddingSizeY,
          marginSizeX = optionsGridLayout.marginSizeX,
          marginSizeY = optionsGridLayout.marginSizeY,
          isAutoSize = optionsGridLayout.isAutoSize,
          isAllowOverlap = optionsGridLayout.isAllowOverlap,
          isPreventCollision = optionsGridLayout.isPreventCollision,
          isShowGrids = optionsGridLayout.isShowGrids,
          staticHeight = optionsGridLayout.staticHeight;
      var hoveredbackgroundColor = isShowGrids ? "rgba(128, 134, 138, 0.5)" : "rgba(33, 133, 208, 0.5)";
      var backgroundColor = hovered || isShowGrids ? hoveredbackgroundColor : "white";
      var gridSize = this.props.gridSize ? this.props.gridSize : 1;
      var rowHeight = staticHeight || 70;
      return connectDropTarget( /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(Segment, {
        style: {
          background: backgroundColor,
          minHeight: 450
        }
      }, /*#__PURE__*/_react.default.createElement(_GridDivider.default, {
        container: container.current,
        showDividers: hovered || isShowGrids,
        setRow: this.setRow,
        cols: gridSize,
        setCol: this.setCol,
        rowHeight: rowHeight
      }), /*#__PURE__*/_react.default.createElement("form", null, /*#__PURE__*/_react.default.createElement(ResponsiveGridLayout, {
        autoSize: isAutoSize,
        allowOverlap: isAllowOverlap,
        preventCollision: isPreventCollision,
        containerPadding: [Number(containerPaddingSizeX) || 0, Number(containerPaddingSizeY) || 0],
        margin: [Number(marginSizeX) || 0, Number(marginSizeY) || 0],
        rowHeight: rowHeight,
        onResizeStop: this.handleDrawable,
        onDragStop: this.handleDrawable,
        cols: {
          lg: gridSize,
          md: gridSize,
          sm: gridSize,
          xs: gridSize,
          xxs: gridSize
        },
        compactType: null // preventCollision

      }, this.props.objectsForm // .filter((res) => res.i !== "step-0") // sacar del builder la vista de btn parientes
      .map(function (item) {
        return itemForm(item, _this3.handleItemSelected, handleRemoveItem, itemProperties.i);
      }))))));
    }
  }]);

  return FormContainerDnd;
}(_react.Component);

var _default = (0, _reactDnd.DropTarget)("item", elementTarget, collect)(FormContainerDnd);

exports.default = _default;